import ProjectMenu from "../components/projectComponents/ProjectMenu";

function Details() {

    console.log('Render Details.js');
    return (
        <>
            <ProjectMenu />
        </>
    )
}

export default Details